import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import "@gdk/card-selections/dist/styles/gdk-card-selections.css";
import "../../styles/ActivePromotionsVersionTwo.css";
import { UserIncentiveSummaryContext } from "../../context/userContext";
import * as linesOfBusiness from "../../utils/constants/linesOfBusiness";
import { getIcons } from "../../helpers/incentiveHelper";
import { promotionTrackId } from "../../services/gtm/pageNames";


const ActivePromotionsVersionTwo = ({
  updateChosenIncentiveId,
  principalFilter,
  chosenIncentiveId,
  liveEarnings,
}) => {
  const incentiveSummary = useContext(UserIncentiveSummaryContext);
  const [cardsToDisplay, setCardsToDisplay] = useState([]);

  const selectCard = (incentiveId) => {
    const allRadioCards = document.querySelectorAll(".radio-card-v2");
    allRadioCards.forEach((element) => {
      element.classList.remove("selected");
    });

    const selectedCard = document.querySelector(`.radio-card-${incentiveId}`);
    if (selectedCard) {
      selectedCard.classList.add("selected");
      updateChosenIncentiveId(incentiveId);
    }
  };

  useEffect(() => {
    if (!incentiveSummary) return;
    if (principalFilter === "Agency") {
      setCardsToDisplay(incentiveSummary.filter((data) => data.isAgencyOnly));
    } else if (principalFilter === "Producer") {
      setCardsToDisplay(incentiveSummary.filter((data) => !data.isAgencyOnly));
    } else {
      setCardsToDisplay(incentiveSummary);
    }
  }, [incentiveSummary, principalFilter]);

  useEffect(() => {
    if (chosenIncentiveId) {
      selectCard(chosenIncentiveId);
    }
  }, [chosenIncentiveId, selectCard]);

  const formatEarnings = (data) => {
    const earnings =
      liveEarnings?.[data.incentiveId] != null
        ? liveEarnings[data.incentiveId]
        : data.totalEarnings;

    return `$${earnings.toLocaleString()} earned`;
  };

  if (!incentiveSummary || incentiveSummary.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="active-promotions-section-header">Active Promotions</div>
      <div className="card-selection-wrapper" id="card-wrapper">
        <div className="card-selections" id="card-selections-container">
          {cardsToDisplay.map((data) => {
            const sameLineCount = cardsToDisplay
              .slice(0, cardsToDisplay.indexOf(data))
              .filter((card) => (card.lineOfBusiness || "") === (data.lineOfBusiness || "")).length;
            const radioId = promotionTrackId(data.lineOfBusiness, sameLineCount);
            return (
            <label
              key={data.incentiveId}
              className={`radio-card-v2 radio-card-${
                data.incentiveId
              } ${data.incentiveType.toUpperCase()}`}
              id={data.incentiveId}
              aria-label={`Select promotion: ${data.incentiveName}`}
            >
              <input
                type="radio"
                name="incentiveSelection"
                value={data.incentiveId}
                checked={chosenIncentiveId === data.incentiveId}
                onChange={() => selectCard(data.incentiveId)}
                className="sr-only"
                data-trackid={radioId}
                data-track-group="active-promotions"
              />
              <div className="radio-card-v2-inner">
                <div className="card-selections-icon">
                  {getIcons(data)}
                </div>
                <h2 className="active-promotion-title">{data.incentiveName}</h2>
                <div className="active-promotion-money-earned money-green">
                  {formatEarnings(data)}
                </div>
              </div>
            </label>
            );
          })}
        </div>
      </div>
    </div>
  );
};

ActivePromotionsVersionTwo.propTypes = {
  updateChosenIncentiveId: PropTypes.func.isRequired,
  principalFilter: PropTypes.string.isRequired,
  chosenIncentiveId: PropTypes.string.isRequired,
  liveEarnings: PropTypes.object.isRequired,
};

export default ActivePromotionsVersionTwo;
